import { summarizeSession } from "./session.js";
import { wordById } from "./word-set.js";
/** Session record export (idea.md §11.2) — metadata only, never audio. */
export function buildSessionRecord(s) {
    const summary = summarizeSession(s);
    return JSON.stringify({
        ...s,
        audioIncluded: false,
        attempts: s.attempts.map((a) => ({
            ...a,
            t0: round(a.t0 / 1000),
            t1: round(a.t1 / 1000),
            segments: a.segments.map((seg) => ({
                ...seg,
                t0: round(seg.t0 / 1000),
                t1: round(seg.t1 / 1000),
                tag: seg.tag ? { ...seg.tag, at: new Date(seg.tag.at).toISOString() } : null,
            })),
            attemptTags: a.attemptTags.map((t) => ({
                ...t,
                at: new Date(t.at).toISOString(),
            })),
        })),
        summary,
    }, null, 2);
}
/** Reduced, audio-free handoff (idea.md §11.3). No raw tags, no clinical language. */
export function buildParentSummary(s, ws) {
    const { byWord, attempts } = summarizeSession(s);
    const lines = [];
    lines.push(`# Practice summary — ${ws.title}`);
    lines.push("");
    lines.push(`Session: ${new Date(s.startedAt).toLocaleString()}`);
    lines.push(`Words practiced: ${Object.keys(byWord).length} · attempts: ${attempts}`);
    lines.push("");
    lines.push("| Word | Tries | Best takes | Got it |");
    lines.push("|---|---|---|---|");
    for (const [wordId, w] of Object.entries(byWord)) {
        const word = wordById(ws, wordId);
        const got = w.accuracy === null ? "—" : `${Math.round(w.accuracy * 100)}% of reviewed`;
        lines.push(`| ${word?.text ?? wordId} | ${w.attempts} | ${w.starred} | ${got} |`);
    }
    lines.push("");
    const notes = s.attempts.filter((a) => a.notes.trim()).map((a) => {
        const word = wordById(ws, a.wordId);
        return `- ${word?.text ?? a.wordId} #${a.index}: ${a.notes.trim()}`;
    });
    if (notes.length > 0) {
        lines.push("## Notes");
        lines.push(...notes);
        lines.push("");
    }
    lines.push("## Practice at home");
    for (const d of ws.drills) {
        lines.push(`- **${d.title}**: ${d.wordIds.map((id) => wordById(ws, id)?.text ?? id).join(", ")} × ${d.repetitions}`);
    }
    lines.push("");
    lines.push("_Progress is compared to earlier practice only. Not a test._");
    return lines.join("\n");
}
export function downloadText(filename, text, mime) {
    const blob = new Blob([text], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
function round(x) {
    return Math.round(x * 1000) / 1000;
}
